import { Link } from "react-router-dom";
import { PRODUCTS } from "@/data/site";
import { GlowOrb } from "@/components/common/GlowOrb";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/seo/Seo";

export default function Products() {
  return (
    <div data-testid="products-page">
      <Seo
        title="Products"
        description="Explore CloudLab's flagship enterprise products: Acadmax ERP, Libmax library platform, UniCRM.ai admissions CRM, HelloSir.ai AI concierge, TeachingSoftware.ai and VisaInterviews.ai."
        keywords="Acadmax, Libmax, UniCRM.ai, HelloSir.ai, TeachingSoftware.ai, VisaInterviews.ai, enterprise SaaS, education software, AI products"
      />
      <section className="relative overflow-hidden py-20 md:py-28">
        <GlowOrb className="top-0 right-0" color="secondary" size={500} />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-primary mb-4">Products</div>
          <h1 className="font-heading font-black tracking-tighter text-5xl md:text-6xl lg:text-7xl max-w-4xl leading-[0.95]">
            Enterprise SaaS, <span className="text-gradient-aurora">built AI-first.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-muted-foreground">
            Four production-grade products serving thousands of users across six countries.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-6">
          {PRODUCTS.map((p) => (
            <Link
              to={`/products/${p.slug}`}
              key={p.slug}
              className="group glass rounded-3xl overflow-hidden hover:border-primary/50 transition-colors"
              data-testid={`products-page-card-${p.slug}`}
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              </div>
              <div className="p-8">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading font-bold text-2xl">{p.name}</h3>
                  <ArrowUpRight className="w-5 h-5 text-primary" />
                </div>
                <p className="mt-2 text-muted-foreground">{p.tagline}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
